import { Paragraph } from '@/components/Paragraph';
import { withLayoutProps } from '@/utils/withLayoutProps';

import { StyledInfo, StyledNameTag, StyledProfileImage } from './styles';

interface NameTagProps {
  name: string;
  subtitle: string;
  imageUrl: string;
}

export const NameTag = withLayoutProps(({ name, subtitle, imageUrl, ...props }: NameTagProps) => (
  <StyledNameTag {...props}>
    <StyledProfileImage src={imageUrl} alt="profile" />
    <StyledInfo>
      <Paragraph size="lg" weight={700}>
        {name}
      </Paragraph>
      <Paragraph>{subtitle}</Paragraph>
    </StyledInfo>
  </StyledNameTag>
));
